import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const trashedPlanDirectLinkRoute: InvariantJiraRoute = {
	name: 'trashed-plan-direct-link',
	path: '/jira/plans/plan-trashed',
	exact: true,
};
